export const PROGRAM_MODE = 'program';
export const BROADCAST_MODE = 'enriched_broadcast';
export const AUTOMATED_MODE = 'automated_broadcast';
export const ONBOARDER = 'onboarder';
export const CONTENT = 'content';



// WEBPACK FOOTER //
// ./src/constants/EditorMode.js